import { render } from "./SidebarIntro.vue?vue&type=template&id=0984f1b8&scoped=true"
import script from "./SidebarIntro.vue?vue&type=script&lang=js"
export * from "./SidebarIntro.vue?vue&type=script&lang=js"

import "./SidebarIntro.vue?vue&type=style&index=0&id=0984f1b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0984f1b8"]])

export default __exports__